<div #chartContainer [attr.id]="chartPerfId" style="min-width: 310px; height: 400px; margin: 0 auto"></div>
